import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { SummaryItem, TabComponent, TabFormModalComponent } from 'tms-lib';
import { AddressDetails, AddressService } from 'tms-web-shared';
import { AddressDetailsComponent } from '../address-details/address-details.component';
import { AddressAddresseesComponent } from '../address-addressees/address-addressees.component';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
  imports: [TabFormModalComponent, TabComponent, AddressDetailsComponent, AddressAddresseesComponent, AsyncPipe],
})
export class AddressComponent implements OnInit {
  protected readonly addressService = inject(AddressService);
  private readonly route = inject(ActivatedRoute);

  public readonly id = model<string>();
  public readonly isModal = model(false);

  protected readonly detailsHeader = $localize`Details`;
  protected readonly addresseeHeader = $localize`Addressees`;

  protected model$: Observable<AddressDetails>;

  ngOnInit() {
    this.getModel();
  }

  summaryTopItems(model: AddressDetails): SummaryItem[] {
    return [
      { label: $localize`Addressee`, value: model.addressee },
      { label: $localize`Name`, value: model.name },
    ];
  }

  getModel() {
    if (!this.id()) {
      this.id.set(this.route.snapshot.paramMap.get('id'));
    }
    if (this.id()) {
      this.model$ = this.addressService.edit(this.id());
    }
  }
}
